<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
      <app-articles-view
        [articles]="artArticlesArray"
        [itemsPerPage]="limit"
        [totalcount] ="totalcount"
        (onPaginateEvent) = "onPaginateEvent($event)"
      ></app-articles-view>
  </div>
</div>
<!-- Page content end -->
